import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, resolving Tailwind conflicts (last one wins).
 * Used by all shadcn/ui components and app components alike.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
